// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.has-permission[data-v-b1f6c454] {\n  color: green;\n}\n.does-not-have-permission[data-v-b1f6c454] {\n  color: #ccc;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
